import RadioCards from "@/common/components/RadioCards";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { checkinEntryOptions } from "../../../../constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { CheckinEntryValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingCheckinEntryKlass } from "../../../../types/forwardings/checkinEntries/checkinEntry.type";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepAccordion from "../../../CreateForwardingDirectiveEntryFormStepAccordion";

const CheckinEntryFormStepPending = ({
  state,
  attributes,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.CheckinEntry>) => {
  const {
    control,
    setValue,
  } = useFormContext<CheckinEntryValidationSchema>();

  const { setUpdatedValueAt } = useCreateForwardingsFormStore();

  const {
    checkin_entry_type: watchCheckinEntryType,
  } = useWatch({
    control,
  });

  const EntryOptionComponent = useMemo(() => {
    if (watchCheckinEntryType) {
      const checkinEntryOption = checkinEntryOptions[watchCheckinEntryType as MaintenanceForwardingCheckinEntryKlass];

      return checkinEntryOption.components.pending;
    }

    return null;
  }, [watchCheckinEntryType]);

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Método de check-in"
      body={(
        <div>
          {!watchCheckinEntryType && (
            <RadioCards
              options={
                (attributes as MaintenanceForwardingCheckinEntryKlass[])
                  ?.filter((option) => !!checkinEntryOptions[option])
                  ?.map((option) => {
                    const checkinEntryOption = checkinEntryOptions[option];

                    return {
                      value: option,
                      title: checkinEntryOption.title,
                      description: checkinEntryOption.description,
                    }
                  })}
              value={watchCheckinEntryType}
              onValueChange={(value) => {
                setUpdatedValueAt();
                setValue('checkin_entry_type', value);
              }}
            />
          )}

          {watchCheckinEntryType && EntryOptionComponent && (
            <EntryOptionComponent />
          )}
        </div>
      )}
    />
  )
}

export default CheckinEntryFormStepPending;
